import {
    InvoiceViewOptionGroup,
    InvoiceViewOptions,
} from "@common/types/invoice";

export interface InvoicesUrlFilters {
    invoiceIds?: string[];
    catalogItemIds?: string[];
    entityIds?: number[];
}

interface InvoicesUrlParams {
    /**
     * Deep-link the Schedule column into view and prioritise this template —
     * see views/scheduleColumnHandoff.ts.
     */
    scheduleTemplateId?: string;
    invoiceId?: string;
    groupBy?: InvoiceViewOptionGroup;
}

export function resolveInvoiceDeepLinkFilters({
    filters,
    invoiceId,
}: {
    filters?: InvoicesUrlFilters;
    invoiceId?: string;
}): InvoicesUrlFilters | undefined {
    if (!filters && !invoiceId) {
        return;
    }
    return {
        ...filters,
        ...(invoiceId && { invoiceIds: [invoiceId] }),
    };
}

export function resolveInvoiceDeepLinkView({
    filters,
    groupBy,
    fallback,
}: {
    filters?: InvoicesUrlFilters;
    groupBy?: InvoiceViewOptionGroup;
    fallback?: InvoiceViewOptions;
}): InvoiceViewOptions {
    if (groupBy) {
        return { groupBy };
    }
    if (filters?.invoiceIds?.length) {
        return { groupBy: InvoiceViewOptionGroup.INVOICE };
    }
    if (filters?.catalogItemIds?.length) {
        return { groupBy: InvoiceViewOptionGroup.LINE_ITEMS };
    }
    return (
        fallback ?? {
            groupBy: InvoiceViewOptionGroup.COUNTERPARTY,
        }
    );
}

export function createInvoicesUrl(
    filters: InvoicesUrlFilters,
    params: InvoicesUrlParams = {},
): string {
    const search = new URLSearchParams();
    const serialized = JSON.stringify(filters);
    if (serialized && serialized !== "{}") {
        search.set("filters", serialized);
    }
    if (params.scheduleTemplateId) {
        search.set("scheduleTemplateId", params.scheduleTemplateId);
    }
    if (params.invoiceId) {
        search.set("invoiceId", params.invoiceId);
    }
    if (params.groupBy) {
        search.set("groupBy", params.groupBy);
    }
    const query = search.toString();
    return query ? `/invoicing?${query}` : "/invoicing";
}
